var checkExistRC = setInterval(function() {
	let rechargeForm = document.querySelector('.rc-widget');
  // Check if RC widget exists on the page, if not, check again in 100ms
  if (rechargeForm) {
    // Clear interval so this only runs once
    clearInterval(checkExistRC);

    // DOM elements 
    let optionsContainer = document.querySelector('.option-selectors');
    let rcTriggers = document.querySelectorAll('.rc-radio__input');
    let rcDescBtn = document.querySelector('.rc-subscription-details__button');
    

    function buildFreqBtns(){
    	const freqDescList = ['1 month - avg 2 showers/day','2 months - avg 1 shower/day','3 months - Intermittent use/travelers']
    	let parentCont = document.querySelector('.rc-widget');
    	let freqSelect = parentCont.querySelector('.rc-selling-plans-dropdown__select');
			//Make div for new frequency buttons
			let newFreqDiv = document.createElement("div");
	    newFreqDiv.classList.add("option-selector__btns");
	    let rcSP = parentCont.querySelector(".rc-selling-plans");
	    
	    //loop through frequency select to build as buttons
			freqSelect.querySelectorAll('option').forEach((opt, idx) =>{
				//Make Label
				let freqLabel = document.createElement("label");
				let freqDescSpan = document.createElement("span");
				let editOptText = opt.innerText.replace("every","every <br/>");
				let titleText = document.createTextNode(editOptText);
				let freqDescText = document.createTextNode(freqDescList[idx]);

				freqDescSpan.appendChild(freqDescText);
				freqDescSpan.classList.add("sm-desc");
				freqLabel.innerHTML = editOptText;
				freqLabel.classList.add("opt-label","freq");
				freqLabel.htmlFor = "cs-freq-radio-"+opt.value;
				//Make Input
				let freqInput = document.createElement("input");
				freqInput.classList.add("opt-btn","js-option");
				freqInput.value = opt.value;
				freqInput.id = "cs-freq-radio-"+opt.value;
				freqInput.name = "cs-freq-radio";
				freqInput.type = "radio";
				if(idx===0){
					freqInput.checked = true;
					freqSelect.value = opt.value;
					freqSelect.dispatchEvent(new Event('change'));
				}

				//
				freqInput.addEventListener('click', e => {
					freqSelect.value = e.target.value;
					freqSelect.dispatchEvent(new Event('change'));
				});
				
				newFreqDiv.appendChild(freqInput);
				freqLabel.appendChild(freqDescSpan);
				newFreqDiv.appendChild(freqLabel);
			});

			//add to the new div
			rcSP.appendChild(newFreqDiv);
			freqSelect.style.display = 'none';
		}

    //add title above widget
    const newNodeTitle = document.createElement("div");
    newNodeTitle.classList.add("label");
  	const titleText = document.createTextNode("Choose Your Price:");
  	newNodeTitle.appendChild(titleText);
  	const sib = document.querySelector(".rc-template__button-group");
		const parentDiv = sib.parentNode;
		parentDiv.insertBefore(newNodeTitle, sib);


		buildFreqBtns();

    // For each selling option
    rcTriggers.forEach(trig =>{

		if(trig.closest('label').classList.contains('rc-radio--active') && trig.value == 'subscription') {
		    // hide variants if subscription is selected on load
		    optionsContainer.style.display = 'none';
		}

		// Add an onclick event listener
		trig.addEventListener('click', e => {
			
			// If the variant selected matches the no subscription variable
			if (e.target.value == 'subscription') {
			  // Hide Variants and click first option   
			  document.querySelector('.option-selectors .option-selector__btns input:first-child').click();       
			  optionsContainer.style.display = 'none';
			  rcDescBtn.style.display = 'block';
			  let waitForBuild = setInterval(function() {
			  	clearInterval(waitForBuild);
			  	buildFreqBtns();
			  }, 50); // check every 100ms

			} else {
			  // Show RC widget
			  optionsContainer.style.display = 'block';
			  rcDescBtn.style.display = 'none';
			}
		});

		

    })

  } 
}, 100); // check every 100ms